import { Component, forwardRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MenuService } from '../../../services/menu.service';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { PanelModule } from '../../../modules/panel.module';

@Component({
  selector: 'brt-menu-item-option-visibility',
  templateUrl: './menu-item-option-visibility.component.html',
  standalone: true,
  imports: [PanelModule],
  styleUrl: './menu-item-option-visibility.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MenuItemOptionVisibilityComponent),
      multi: true
    }
  ]
})
export class MenuItemOptionVisibilityComponent {
  options: any[];
  businessId: string;
  constructor(route: ActivatedRoute, menuService: MenuService) {
    route.params.subscribe(async params => {
      this.businessId = params['bid'];
      menuService.searchMenuOption({ BusinessId: this.businessId }).then(result => this.options = result.List);
    });
  }

  value: any;

  writeValue(value: any) { this.value = value || {}; }
  registerOnChange(fn: any) { this.onChange = fn; }
  registerOnTouched(fn: any) { this.onTouched = fn; }
  onChange = (_: any) => { };
  onTouched = () => { };
  valueChanged() { setTimeout(() => this.onChange(this.value)); }
}
